import React from "react";
import Heading from "./Heading";

function PageLayout({ heading, description, children, ...props }) {
  return (
    <React.Fragment {...props}>
      <div className="flex flex-col gap-4 mb-4">
        <Heading as="h1">{heading}</Heading>
        <p className="text-muted-foreground">{description}</p>
      </div>
      {children}
    </React.Fragment>
  );
}

export default PageLayout;
